/** Same-origin /api when REACT_APP_BACKEND_URL is empty (Cursor port-forward + OVH nginx). */
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

/**
 * Normalize API request URLs for local dev proxy and FastAPI trailing-slash redirects.
 * - Collapses accidental /api/api/ double prefix
 * - Strips absolute localhost backend URLs when using same-origin proxy
 * - Adds trailing slash on top-level collection routes (e.g. /api/employees) to avoid
 *   307 redirects that drop Authorization headers in the browser
 */
export function normalizeApiUrl(url) {
  if (typeof url !== 'string' || !url) return url;

  let normalized = url;

  // Fix double /api prefix (API constant already includes /api)
  normalized = normalized.replace(/\/api\/api\//g, '/api/');

  // When proxying via craco, keep requests same-origin
  if (!BACKEND_URL) {
    normalized = normalized.replace(/^https?:\/\/(?:127\.0\.0\.1|localhost):8001(?=\/)/, '');
  }

  // FastAPI collection routes are defined with trailing slash; avoid 307 redirect
  const [pathPart, ...queryParts] = normalized.split('?');
  const query = queryParts.length ? `?${queryParts.join('?')}` : '';
  const segments = pathPart.split('/').filter(Boolean);
  if (
    segments.length === 2 &&
    segments[0] === 'api' &&
    !pathPart.endsWith('/')
  ) {
    normalized = `${pathPart}/${query}`;
  }

  return normalized;
}
